<template>
  <div>
    <b-alert show class="bg-light">
      This pixel will be appended to the percent of requests chosen.
      If the pixel content is a URL, it will also be appended to VAST
      bids as an impression entry. If HTML, it will only be added to
      banner creatives.
    </b-alert>
    <b-card title="Global Data Sample">
      <b-row>
        <b-col lg="4">
          <b-form-group title="Sample Percent"
                        description="% of ALL exchange data and activity to store a sample of">
            <b-form-select v-model="config.storage_sample_rate">
              <option :value="0">Disabled</option>
              <option :value="1">1%</option>
              <option :value="2">2%</option>
              <option :value="3">3%</option>
              <option :value="4">4%</option>
              <option :value="5">5%</option>
              <option :value="6">6%</option>
              <option :value="7">7%</option>
              <option :value="8">8%</option>
              <option :value="9">9%</option>
              <option :value="10">10%</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-card title="Global Blocks" class="mt-3">
      <b-row>
        <b-col md="12">
          <b-form-group label="List of blocked pub id or bundle values">
            <string-list-editor :values="config.req_id_blacklist"
                                placeholder="Enter blocks (pubid or bundles)"></string-list-editor>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-card title="Global Pixel" class="mt-3">
      <b-row>
        <b-col>
          <b-form-group title="Pixel content"
                        description="Pixel URL or html with macros">
            <b-form-textarea rows="6" v-model="config.pixel.content" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4">
          <b-form-group title="Throttle"
                        description="% of bids to include pixel">
            <b-form-select v-model="config.pixel.throttle">
              <option :value="100">1%</option>
              <option :value="20">5%</option>
              <option :value="10">10%</option>
              <option :value="5">20%</option>
              <option :value="4">25%</option>
              <option :value="3">30%</option>
              <option :value="2">50%</option>
              <option :value="1">100%</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-row class="mt-4">
      <b-col>
        <b-btn @click="save()" variant="primary">Save</b-btn>
      </b-col>
    </b-row>
    <b-card title="Macros" class="mt-4">
      <b-alert show>
        If a macro value is not available, it will be replaced with an empty string ("")
      </b-alert>
      <b-row v-for="macro in macros" :key="macro.label">
        <b-col lg="4">
          <b-badge variant="primary">
            {{ macro.label }}
          </b-badge>
        </b-col>
        <b-col>
          {{ macro.description }}
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
  import { MiscApi } from "../../api"
  import StringListEditor from "../../components/StringListEditor.vue";

  export default {
      name: 'GlobalConfig',
    components: {StringListEditor},
      created () {
        MiscApi.getGlobalConfig().then((config) => {
            this.config = Object.assign(this.defaultConfig(), config)
        })
      },
      data () {
          return {
              config: this.defaultConfig(),
              macroMap: {
                  AUCTION_ID: 'Auction ID',
                  PUB_ID: 'Publisher ID',
                  PUB_NAME: 'Publisher name',
                  APP_NAME: 'App name',
                  APP_BUNDLE: 'App bundle id',
                  APP_STORE_URL: 'App store url',
                  SEAT: 'Buyer seat',
                  BID_CID: 'Bid campaign id',
                  BID_CRID: 'Bid creative id',
                  ZONE_ID: 'Placement id / impression tagid',
                  SITE_URL: 'URL of page',
                  SITE_DOMAIN: 'Site domain',
                  MED_TYPE: '"App" or "Site"',
                  BID_FORMAT: '"Banner" or "Video" or "Native"',
                  IMP_ID: 'Impression id',
                  DEV_OS: 'Device OS',
                  DEV_ID: 'Device IDFA/GAID',
                  DEV_UA: 'Device user agent',
                  DEV_IP: 'Device IP',
                  DEV_GEO: '3 letter country code',
                  DEV_LAT: 'Geo lat value',
                  DEV_LONG: 'Geo lon value',
                  DEV_ISP: 'ISP/carrier name',
                  SELLER_ID: 'Exchange/Publisher company id',
                  DEV_MAKE: 'Device make (apple)',
                  DEV_MODEL: 'Device model (iphone)',
                  USER_ID: 'User id (site)',
                  BID_WIDTH: 'Bid width',
                  BID_HEIGHT: 'Bid height',
                  DNT: 'Do Not Track',
                  GDPR: '1 if GDPR applies, 0 if not',
                  GDPR_CONSENT: 'GDPR consent string',
                  BANNER_WIDTH: 'Width of banner object in request',
                  BANNER_HEIGHT: 'Height of banner object in request',
                  VIDEO_WIDTH: 'Width of video object in request',
                  VIDEO_HEIGHT: 'Height of video object in request'
              }
          }
      },
      computed: {
          macros () {
              let map = this.macroMap

              let list = []
              for(let key in map) {
                  list.push({ label: '{' + key + '}', description: map[key] })
              }

              return list
          }
      },
      methods: {
          defaultConfig () {
              return {
                  storage_sample_rate: 1,
                  req_id_blacklist: [],
                  pixel: {
                      content: null,
                      throttle: 10
                  }
              }
          },
          save() {
              MiscApi.saveGlobalConfig(this.config).then(() => {
                  this.$notify.success("Config Saved")
              })
          }
      }
  }
</script>



// WEBPACK FOOTER //
// src/admin/pages/GlobalConfig.vue